import { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import EventosTabs from '../components/tabs/AppMovilTabs/EventosTabs';
import RecursosTabs from '../components/tabs/AppMovilTabs/RecursosTabs';

function AppMovilPage() {
    const [value, setValue] = useState(0);

    return (
        <Box sx={{ width: '100%' }}>
            <Tabs
                value={value}
                onChange={(_, newValue) => setValue(newValue)}
                aria-label="app movil tabs"
                sx={{ mb: 2 }}
            >
                <Tab label="Eventos" />
                <Tab label="Recursos" />
            </Tabs>

            {value === 0 && (
                <Box>
                    <EventosTabs />
                </Box>
            )}

            {value === 1 && (
                <Box>
                    <RecursosTabs />
                </Box>
            )}
        </Box>
    );
}

export default AppMovilPage;
